import axios from "axios";
import { apiURL } from "../config/default";
import setAuthHeader from "../utils/setAuthHeader";

export const newsletterSubs = (formData) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const regionName = "us5";
    const apiKey = "9b19cefbf85c58e481af64d623df8f82-us5";
    const listId = "bb5a99bb62";
    const url = `https://${regionName}.api.mailchimp.com/3.0/lists/${listId}/members/`;

    axios
      .post(
        url,
        {
          // Tell Mailchimp to subscribe this email
          status: "subscribed",
          // Note that Mailchimp takes an email_address field, not just email
          email_address: formData.email,
        },
        {
          headers: {
            Authorization: `apikey ${apiKey}`,
          },
        }
      )
      .then(() => {
        // Things went well
        console.log("workings");
      });

    // await axios.post(
    //   `https://us5.api.mailchimp.com/3.0/lists/${listId}/9b19cefbf85c58e481af64d623df8f82-us5/members/`,
    //   {
    //     email_address: formData.email,
    //     status: "subscribed",
    //     merge_fields: {
    //       FNAME: "New",
    //       LNAME: "User",
    //     },
    //   },
    //   _config
    // );

    const res = await axios.post(
      `${apiURL}newsletter-subscribe`,
      formData,
      _config
    );
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const editNewsletter = (formData) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }
  try {
    const res = await axios.post(`${apiURL}newsletter`, formData, _config);
    return res.data;
  } catch (err) {
    console.log(err.response.data.error);
  }
};
